export default __webpack_public_path__ + "static/media/star-gold-icon.14b3b9a2.svg";